import { strIsNullOrEmpty, TextField, tryParseJSONObject } from '@fox/atoms';
import { useSwiftFoxTenantConfigContext } from '../../../swiftfox-tenant-config-context';
import { ActionCentreFilterProps } from './contracts';
// for the address filter we just add these 3 fields per address we want to filter on
// this one does not care that much about the dataIndex but more aobut the titleto identify the address type in the backend
export function AddressFilter({ column, onChange, filter, showAddressTypes }: ActionCentreFilterProps) {
	const { addressLocalisations } = useSwiftFoxTenantConfigContext();

	if (!addressLocalisations) return null;
	const suburbLabel = addressLocalisations.addressParts.suburb;
	const stateLabel = addressLocalisations.addressParts.state;
	const parsedValue = filter?.filterValue
		? tryParseJSONObject<{ locality?: string; postcode?: string; state?: string }>(filter?.filterValue)
		: undefined;
	return (
		<>
			<TextField
				value={parsedValue?.locality ?? ''}
				onChange={e => {
					if (!strIsNullOrEmpty(e.target.value)) {
						onChange(JSON.stringify({ ...parsedValue, locality: e.target.value }));
					} else {
						if (!parsedValue?.postcode && !parsedValue?.state) {
							onChange(undefined);
						} else {
							onChange(JSON.stringify({ ...parsedValue, locality: undefined }));
						}
					}
				}}
				size="small"
				placeholder={showAddressTypes ? `${column.title} ${suburbLabel.toLocaleLowerCase()}` : suburbLabel}
			/>
			<TextField
				value={parsedValue?.postcode ?? ''}
				type="number"
				onChange={e => {
					if (!strIsNullOrEmpty(e.target.value)) {
						onChange(JSON.stringify({ ...parsedValue, postcode: e.target.value }));
					} else {
						if (!parsedValue?.locality && !parsedValue?.state) {
							onChange(undefined);
						} else {
							onChange(JSON.stringify({ ...parsedValue, postcode: undefined }));
						}
					}
				}}
				size="small"
				placeholder={showAddressTypes ? `${column.title} postcode` : 'Postcode'}
			/>
			<TextField
				value={parsedValue?.state ?? ''}
				onChange={e => {
					if (!strIsNullOrEmpty(e.target.value)) {
						onChange(JSON.stringify({ ...parsedValue, state: e.target.value }));
					} else {
						if (!parsedValue?.postcode && !parsedValue?.locality) {
							onChange(undefined);
						} else {
							onChange(JSON.stringify({ ...parsedValue, state: undefined }));
						}
					}
				}}
				size="small"
				placeholder={showAddressTypes ? `${column.title} ${stateLabel.toLocaleLowerCase()}` : stateLabel}
			/>
		</>
	);
}
